<template>
  <div v-ripple class="match-overview font-smaller">
    <div class="pt-2 text-truncate primary--text font-weight-bold float-left">
      <span class="d-sr-only">{{ showSubject ? "Subject" : "Category" }}:</span>
      {{ displayGrouping }}
    </div>
    <div
      v-if="showContentTag"
      :class="contentTypeAlignLeft ? 'float-left ml-4' : 'float-right'"
    >
      <span class="d-sr-only">,</span>
      <ContentTag :article="article" />
    </div>
    <div
      v-if="community"
      :class="contentTypeAlignLeft ? 'float-left' : 'float-right'"
    >
      <span class="d-sr-only">,</span>
      <ContentTag
        :tag-text="community.name"
        background-color="primary"
        foreground-color="white"
      />
    </div>

    <div
      class="match-overview__title-container mt-2 font-smaller overflow-hidden has-action"
    >
      <span class="d-sr-only">, Title:</span>
      <h3>
        <ArticleTitle :article-html-title="article.title" />
      </h3>
    </div>
    <div class="pt-2 font-small font-weight-bold text-truncate">
      <span class="d-sr-only">, Authors:</span>
      {{
        article.authors
          | sorted("displayOrder")
          | concatenateValues(["firstName", "lastName"])
      }}
    </div>
    <div
      v-if="showVersionAndPublishedDate"
      class="pt-2 font-small font-weight-bold text-truncate"
    >
      {{ versionAndPublishedDate }}
    </div>
    <div v-if="showSubmittedDate" class="mt-2 caption font-small text-left">
      <span>Submitted</span>
      <span class="font-weight-bold">
        {{ article.submittedDate | localDate }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ArticleTitle from "~/components/articles/components/ArticleTitle.vue";
import ContentTag from "~/components/articles/components/ContentTag.vue";
import localDateTime from "~/plugins/utilities/localDateTime";
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  name: "MatchOverview",
  components: {
    ContentTag,
    ArticleTitle,
  },
  props: {
    article: { type: Object, required: true },
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
    }),
    ...mapFlags([
      "showContentTypeSearch",
      "showSubmittedDateOnContentCards",
      "showSearchDashboardVersionAndPublishedDate",
    ]),
    showSubject() {
      return this.layout.matchOverviewShowSubject;
    },
    showCategory() {
      return this.layout.matchOverviewShowCategory;
    },
    showContentTag() {
      return this.showContentTypeSearch;
    },
    showSubmittedDate() {
      return (
        this.article?.submittedDate && this.showSubmittedDateOnContentCards
      );
    },
    community() {
      return this.article.community;
    },
    contentTypeAlignLeft() {
      return this.layout.matchOverviewContentTypeAlignLeft;
    },
    displayGrouping() {
      const { article, showSubject, showCategory } = this;

      const subjectName = showSubject ? article?.subjectType?.name : "";
      const categoryName = showCategory ? article?.mainCategory?.name : "";
      const conjunction = showSubject && showCategory ? ", " : "";

      return `${subjectName}${conjunction}${categoryName}`;
    },
    showVersionAndPublishedDate() {
      return this.showSearchDashboardVersionAndPublishedDate;
    },
    versionAndPublishedDate() {
      const { article } = this;
      const localPublishedDate = localDateTime(
        article.publishedDate,
        "dd LLLL yyyy"
      );

      return `Version ${article.version} posted ${localPublishedDate}`;
    },
  },
};
</script>

<style lang="scss">
.match-overview {
  a {
    color: inherit;
    text-decoration: none;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  h3 {
    font-size: 14px;
    font-weight: normal;
  }
  &__title-container {
    clear: both;
  }
}
</style>
